function Notifications() {
  return (
    <div>
      <h1 className="text-4xl font-bold mb-8">Notifications</h1>
      <div className="space-y-4">
        <div className="bg-white p-4 rounded-xl shadow-sm">
          <p className="text-gray-900">
            Product "Wireless Headphones" published successfully to Amazon UAE
          </p>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-red-200">
          <p className="text-red-500">
            Failed to publish to Noon UAE - Please check API credentials
          </p>
        </div>
      </div>
    </div>
  );
}

export default Notifications;